var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-box"},[_c('div',{staticClass:"box-border"},[_c('div',{staticClass:"box-title"},[_vm._v("MANDIAO INFORMATION")]),_c('div',{staticClass:"box-text"},[_vm._v("漫调资讯")])])])
}]

export { render, staticRenderFns }